import React, { useEffect } from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import BlogCard from "../components/BlogCard";
import Container from "../components/Container";
import {useSelector,useDispatch} from "react-redux";
import { getBlogs,resetState } from "../features/blogs/blogSlice";

const Blog = () => {
  const dispatch = useDispatch();
  const blogState = useSelector((state)=> state.blog.blogs);
  useEffect(()=>{
    dispatch(getBlogs());
    dispatch(resetState());
  },[])
  return (
    <>
      <Meta title={"Blogs"} />
      <BreadCrumb title="Blogs" />
      <Container class1="blog-wrapper home-wrapper-2 py-5">
        <div className="row">
          <div className="col-3">
            <div className="filter-card mb-3">
              <h3 className="filter-title">Find By Categories</h3>
              <div>
                <ul className="ps-0">
                  <li>Watch</li>
                  <li>Tv</li>
                  <li>Camera</li>
                  <li>Laptop</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-9">
            <div className="row">
              <div className="col-6 mb-3 ">
                <BlogCard data={blogState} />
              </div>
              {/* <div className="col-6 mb-3">
                <BlogCard />
              </div>
              <div className="col-6 mb-3">
                <BlogCard />
              </div>
              <div className="col-6 mb-3">
                <BlogCard />
              </div> */}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Blog;